import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { Domain } from 'signup-ui-lego-core/constants/Domain';
export const DomainLocale = new Map([[Domain.Deutch, Locale.de], [Domain.English, Locale.en], [Domain.Japanese, Locale.ja], [Domain.Spanish, Locale.es], [Domain.French, Locale.fr]]);
export const getDomainLocale = domain => {
  return DomainLocale.get(domain);
};